import { SxProps } from "@mui/material";
import { grey } from "@mui/material/colors";

export const wrapperStyles: SxProps = {
  border: 1,
  minHeight: 500,
  borderColor: grey[300],
  boxShadow: "none",
  borderRadius: 0,
};

export const headerCellStyles = (isFirstColumn: boolean): SxProps => ({
  height: "48px",
  fontWeight: "bold",
  borderRight: isFirstColumn ? `1px solid ${grey[300]}` : "none",
  pr: 1,
  py: 1.5,
});

export const dataCellStyles = (isFirstColumn: boolean): SxProps => ({
  borderRight: isFirstColumn ? `1px solid ${grey[300]}` : "none",
  padding: "8px 16px",
  verticalAlign: "middle",
});

export const rowStyles: SxProps = {
  height: "40px",
  backgroundColor: "white",
};

export const headerRowStyles: SxProps = {
  backgroundColor: grey[50],
};
